import {useCallback, useEffect, useState} from 'react';

import {useLocation, useNavigate} from 'react-router-dom';

import {RouteName, getRoute} from 'config/navigation';
import {
  QuestionsToVerificationState,
  ToConfirmationState,
  VerificationToLoginIDState
} from 'features/CreateAccount/types/navigationState';

export const useGetQuestionsToVerificationNavigationState = (): QuestionsToVerificationState | null =>
  useLocation().state;
export const useGetAccountConfirmationNavigationState = (): ToConfirmationState | null => useLocation().state;
export const useGetVerificationToLoginIDState = (): VerificationToLoginIDState | null => useLocation().state;

export const useNavigateToCreateAccountRoutes = () => {
  const navigate = useNavigate();
  const navigateToLoginID = useCallback(
    (loginIDState: VerificationToLoginIDState) => {
      navigate(getRoute('/create-account/loginID'), {
        state: loginIDState
      });
    },
    [navigate]
  );
  const navigateToConfirmation = useCallback(
    (confirmationState: ToConfirmationState) => {
      navigate(getRoute('/create-account/confirmation'), {
        state: confirmationState
      });
    },
    [navigate]
  );
  const navigateToVerification = useCallback(
    (verificationState: QuestionsToVerificationState) => {
      navigate(getRoute('/create-account/accountVerification'), {
        state: verificationState
      });
    },
    [navigate]
  );
  return {
    navigateToLoginID,
    navigateToConfirmation,
    navigateToVerification
  };
};

export const useRedirectToLoginOnBackAfterConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [confirmed, setConfirmed] = useState(false);
  useEffect(() => {
    if (locationMatchesRouteName(location.pathname, '/create-account/confirmation')) {
      setConfirmed(true);
    }
    if (!locationMatchesRouteName(location.pathname, '/create-account/confirmation') && confirmed) {
      navigate(getRoute('/login'));
    }
  }, [confirmed, location.pathname, navigate]);
};

const locationMatchesRouteName = (location: string, routeName: RouteName) => location === routeName;
